import { Utils } from '../dynamicWorkspace';
import { ThemeVariables } from './themeVariables';

/**
 * The theme variables manager.
 *
 * @export
 * @class ThemeVariablesManager
 */
export class ThemeVariablesManager {

    private document: Document;


    /**
     * Creates an instance of ThemeVariablesManager.
     *
     * @param {Document} document The document reference.
     * @memberof ThemeVariablesManager
     */
    public constructor(document: Document) {
        this.document = document;
    }


    /**
     * Resets all variables.
     *
     * @private
     * @memberof ThemeVariablesManager
     */
    public resetVariables(): void {
        const root = this.document.documentElement;

        // @ts-ignore - Object values
        const cssNameValues = Object.values(ThemeVariables);
        for (const cssName of cssNameValues) {
            root.style.setProperty('--' + cssName, null);
        }
    }

    /**
     * Sets the value of the given variable.
     *
     * @param {ThemeVariables} variable The variable to set.
     * @param {string} value The value to use.
     * @memberof ThemeVariablesManager
     */
    public setVariableValue(variable: ThemeVariables, value: string): void {
        this.document.documentElement.style.setProperty('--' + variable, value);
    }

    /**
     * Gets the value of the given variable.
     *
     * @param {ThemeVariables} variable The variable to get.
     * @returns {*}  {(string | undefined)} The value of the variable or undefined.
     * @memberof ThemeVariablesManager
     */
    public getVariableValue(variable: ThemeVariables): string | null {
        let result: string | null = null;

        try {
            let style: CSSStyleDeclaration | null = null;
            if (this.document && this.document.defaultView) {
                style = this.document.defaultView.getComputedStyle(this.document.documentElement);
            } else {
                style = getComputedStyle(this.document.documentElement);
            }

            if (style) {
                const foundPropertyValue = style.getPropertyValue('--' + variable);
                if (Utils.isDefined(foundPropertyValue) && foundPropertyValue !== '') {
                    result = foundPropertyValue;
                }
            }
        } catch (err) {
            result = null;;
        }

        return result;
    }

}